import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.from.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { PendoHelper } from './Pendo';
import { PENDO_API_KEY } from './Constants';
import { UserService } from '../Services/UserService';
import { ConfigurationService } from '../Shared/Configuration';
export var PendoInitializer = /*#__PURE__*/function () {
  function PendoInitializer() {
    _classCallCheck(this, PendoInitializer);
  }

  _createClass(PendoInitializer, null, [{
    key: "Initialize",
    value: function () {
      var _Initialize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(loadedTags) {
        var _yield$Promise$all, _yield$Promise$all2, visitorData, accountData, pendoConfig;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Promise.all([this._GetVisitorData(), this._GetAccountData()]);

              case 3:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                visitorData = _yield$Promise$all2[0];
                accountData = _yield$Promise$all2[1];
                pendoConfig = {
                  visitor: visitorData,
                  account: accountData,
                  location: this._GetLocationConfig(loadedTags)
                };
                PendoHelper.Init(PENDO_API_KEY, pendoConfig);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.error("Error during Pendo initialization:", _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function Initialize(_x) {
        return _Initialize.apply(this, arguments);
      }

      return Initialize;
    }()
  }, {
    key: "_GetVisitorData",
    value: function () {
      var _GetVisitorData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _userInfo$user$roles, userInfo;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return UserService.GetCurrentUser();

              case 3:
                userInfo = _context2.sent;
                return _context2.abrupt("return", userInfo !== null && userInfo !== void 0 && userInfo.user ? {
                  id: userInfo.user.subject,
                  email: userInfo.user.email,
                  full_name: userInfo.user.displayName,
                  roles: ((_userInfo$user$roles = userInfo.user.roles) === null || _userInfo$user$roles === void 0 ? void 0 : _userInfo$user$roles.join(', ')) || '',
                  is_staff: userInfo.isStaff || false,
                  is_head_of_household: userInfo.isHeadOfHousehold || false
                } : null);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", null);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      function _GetVisitorData() {
        return _GetVisitorData2.apply(this, arguments);
      }

      return _GetVisitorData;
    }()
  }, {
    key: "_GetAccountData",
    value: function () {
      var _GetAccountData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var siteInfo;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return ConfigurationService.GetSiteInfo();

              case 3:
                siteInfo = _context3.sent;
                return _context3.abrupt("return", siteInfo ? {
                  id: siteInfo.SiteNumber || '',
                  name: siteInfo.SiteName || ''
                } : null);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", null);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }));

      function _GetAccountData() {
        return _GetAccountData2.apply(this, arguments);
      }

      return _GetAccountData;
    }()
  }, {
    key: "_GetLocationConfig",
    value: function _GetLocationConfig(loadedTags) {
      return {
        setUrl: function setUrl() {
          var baseUrl = ConfigurationService.GetAppRoot();
          var widgetPath = '/Widgets/';
          var combinedTags = loadedTags.join('~');
          return "".concat(baseUrl).concat(widgetPath).concat(combinedTags);
        }
      };
    }
  }]);

  return PendoInitializer;
}();